"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPOGRAPHY = void 0;
var TYPOGRAPHY = {
  HEADING1: 'heading1',
  HEADING2: 'heading2',
  HEADING3: 'heading3',
  HEADING4: 'heading4',
  HEADING5: 'heading5',
  HEADING6: 'heading6',
  HEADING7: 'heading7',
  HEADING7B: 'heading7b',
  HEADING8: 'heading8',
  LARGE_BODY: 'largeBody',
  STANDARD_BODY: 'standardBody',
  SMALL_BODY: 'smallBody',
  LEGAL: 'legal',
  META: 'meta',
  DISCLAIMER: 'disclaimer'
};
exports.TYPOGRAPHY = TYPOGRAPHY;